import React from "react";
import MdmKeyValueTable, { MdmKeyValueTableWrapper } from "./MdmKeyValueTable";

const CONFIG_LOG_TABS = ["device_config", "branding_config", "scan_and_go"];

const buildTableRows = (activeParsed, activeJson) => {
  if (!activeParsed || typeof activeParsed !== "object") {
    return [["value", activeJson]];
  }
  if (Array.isArray(activeParsed)) {
    return activeParsed.map((value, index) => [String(index), value]);
  }
  return Object.entries(activeParsed);
};

const MdmDeviceInfoLogTab = ({
  tab,
  infoJson,
  activeLogResult,
  parsedInfo,
  parsedLog,
  logJson,
  truncateText,
  stringifyForTableCell,
}) => {
  const isInfoTab = tab === "info";
  const activeParsed = isInfoTab ? parsedInfo : parsedLog;
  const activeJson = isInfoTab ? infoJson : logJson;
  const hasNoData = isInfoTab ? infoJson === "No device_info found" : !activeLogResult;
  const hasError = !hasNoData && activeParsed?.status === "Error";
  const hasTableData = isInfoTab ? infoJson !== "No device_info found" : Boolean(activeLogResult);
  const shouldTruncateValues = isInfoTab;
  const isConfigLogTab = CONFIG_LOG_TABS.includes(tab);
  const valueCellClassName = isConfigLogTab
    ? "break-all max-w-[70vw] md:max-w-[720px]"
    : "break-words";
  const formatDisplay = shouldTruncateValues ? truncateText : (raw) => raw;
  const tableRows = hasTableData ? buildTableRows(activeParsed, activeJson) : [];

  return (
    <>
      {hasNoData ? (
        <div className="bg-surface-container-high rounded-lg p-4 text-xs text-on-surface-variant">
          {isInfoTab ? "No device_info found" : "No data found"}
        </div>
      ) : hasError ? (
        <div className="mb-4 bg-error-container text-on-error-container rounded-lg p-4 text-xs font-semibold">
          {activeParsed?.statustext || "Unknown error"}
        </div>
      ) : null}
      {!isInfoTab && activeLogResult?.updated_at && (
        <p className="mb-3 text-[11px] text-on-surface-variant">
          Last updated: {new Date(activeLogResult.updated_at).toLocaleString()}
        </p>
      )}
      <MdmKeyValueTableWrapper>
        {hasTableData && (
          <MdmKeyValueTable
            rows={tableRows}
            stringifyForTableCell={stringifyForTableCell}
            formatDisplay={formatDisplay}
            valueCellClassName={valueCellClassName}
          />
        )}
      </MdmKeyValueTableWrapper>
    </>
  );
};

export default MdmDeviceInfoLogTab;
